// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import PriceCurrency from '@tcp/core/src/components/common/molecules/PriceCurrency';
import { getLocator, getBrandInCaps } from '@tcp/core/src/utils';
import { BUNDLE_PRICE_SECTION, PRICE_COLOR } from '@tcp/core/src/constants/brandSpecific.constants';

const mainPrice = 'main-price';

const productPriceWrapper = (highOfferPrice, lowListPrice, lowOfferPrice, isBundle, classcheck) => {
  return (
    <React.Fragment>
      {!!highOfferPrice && !!lowOfferPrice && highOfferPrice !== lowOfferPrice ? (
        <BodyCopy
          dataLocator={getLocator('global_Price_text')}
          color={isBundle ? BUNDLE_PRICE_SECTION[getBrandInCaps()] : PRICE_COLOR[getBrandInCaps()]}
          fontWeight="extrabold"
          fontFamily="secondary"
          fontSize={['fs15', 'fs18', 'fs20']}
          className={classcheck ? mainPrice : ''}
        >
          <PriceCurrency price={lowOfferPrice} />
          {' - '}
          <PriceCurrency price={highOfferPrice} />
        </BodyCopy>
      ) : (
        <BodyCopy
          dataLocator={getLocator('global_Price_text')}
          color={isBundle ? BUNDLE_PRICE_SECTION[getBrandInCaps()] : PRICE_COLOR[getBrandInCaps()]}
          fontWeight="extrabold"
          fontFamily="secondary"
          fontSize={['fs15', 'fs18', 'fs20']}
          className={classcheck ? mainPrice : ''}
        >
          <PriceCurrency price={lowOfferPrice} />
        </BodyCopy>
      )}
    </React.Fragment>
  );
};

const showProductListPrices = (highListPrice, lowListPrice, lowOfferPrice, isHideOriginalPrice) =>
  !!highListPrice &&
  !!lowListPrice &&
  highListPrice !== lowListPrice &&
  lowOfferPrice !== lowListPrice &&
  !!lowOfferPrice &&
  !isHideOriginalPrice;

const productPriceWrapperForListPrice = (highListPrice, lowListPrice, isBundle, classcheck) => {
  return (
    <React.Fragment>
      {!!highListPrice && !!lowListPrice && highListPrice !== lowListPrice ? (
        <BodyCopy
          dataLocator={getLocator('global_Price_text')}
          color={isBundle ? BUNDLE_PRICE_SECTION[getBrandInCaps()] : PRICE_COLOR[getBrandInCaps()]}
          fontWeight="extrabold"
          fontFamily="secondary"
          fontSize={['fs15', 'fs18', 'fs20']}
          className={classcheck ? mainPrice : ''}
        >
          <PriceCurrency price={lowListPrice} />
          {' - '}
          <PriceCurrency price={highListPrice} />
        </BodyCopy>
      ) : (
        <BodyCopy
          dataLocator={getLocator('global_Price_text')}
          color={isBundle ? BUNDLE_PRICE_SECTION[getBrandInCaps()] : PRICE_COLOR[getBrandInCaps()]}
          fontWeight="extrabold"
          fontFamily="secondary"
          fontSize={['fs15', 'fs18', 'fs20']}
          className={classcheck ? mainPrice : ''}
        >
          <PriceCurrency price={lowListPrice} />
        </BodyCopy>
      )}
    </React.Fragment>
  );
};

export default function (
  highListPrice,
  highOfferPrice,
  lowListPrice,
  lowOfferPrice,
  merchantTag,
  isHideOriginalPrice,
  isBundle,
  classcheck
) {
  const bundleCheck = classcheck && isBundle ? 'wrap-text' : '';
  return (
    <div className={`container-price ${bundleCheck}`}>
      {!lowOfferPrice
        ? productPriceWrapperForListPrice(highListPrice, lowListPrice, classcheck)
        : productPriceWrapper(highOfferPrice, lowListPrice, lowOfferPrice, isBundle, classcheck)}

      {showProductListPrices(highListPrice, lowListPrice, lowOfferPrice, isHideOriginalPrice) ? (
        <span className={`list-price-container ${classcheck ? mainPrice : ''}`}>
          <BodyCopy
            component="span"
            color="gray.700"
            fontFamily="secondary"
            fontWeight="semibold"
            fontSize={['fs10', 'fs12', 'fs14']}
            className="list-price"
            lineHeight="1em"
          >
            <PriceCurrency price={lowListPrice} />
          </BodyCopy>
          <BodyCopy
            component="span"
            color="gray.700"
            fontFamily="secondary"
            fontWeight="semibold"
            fontSize={['fs10', 'fs12', 'fs14']}
            lineHeight="1em"
          >
            {` - `}
          </BodyCopy>
          <BodyCopy
            component="span"
            color="gray.700"
            fontFamily="secondary"
            fontWeight="semibold"
            fontSize={['fs10', 'fs12', 'fs14']}
            className="list-price"
            lineHeight="1em"
          >
            <PriceCurrency price={highListPrice} />
          </BodyCopy>
        </span>
      ) : (
        !!lowOfferPrice &&
        lowListPrice !== lowOfferPrice &&
        !isHideOriginalPrice && (
          <BodyCopy
            component="span"
            color="gray.700"
            fontFamily="secondary"
            fontWeight="semibold"
            fontSize={['fs10', 'fs12', 'fs14']}
            className="list-price"
            lineHeight="1em"
          >
            <PriceCurrency price={lowListPrice} />
          </BodyCopy>
        )
      )}
      {!!merchantTag && !isHideOriginalPrice && (
        <BodyCopy
          component="span"
          color="red.500"
          fontFamily="secondary"
          fontWeight="semibold"
          className="merchant-tag"
          fontSize={['fs10', 'fs12', 'fs14']}
          lineHeight="1em"
        >
          {merchantTag}
        </BodyCopy>
      )}
    </div>
  );
}
